module.exports = __webpack_public_path__ + "static/media/design4.85d2d2c4.png";